






















































































































































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwSelect } from '@libs-uuif/shared/sw-select';
import UUIFComponents from '@/shared/uuifComponent';
import Component from 'vue-class-component';
import { SwModal, SwModalBody, SwModalFooter } from '@sonicwall/unified-ui-framework/src/shared/sw-modal';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';
import { SwTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import RegexValidators from '@/shared/regex-validators';
import { Prop } from 'vue-property-decorator';
import { TooltipDirValues } from '@sonicwall/unified-ui-framework/src/shared/tooltip-dir';
import { confirmService, ConfirmOptions, ConfirmButton } from '@sonicwall/unified-ui-framework/src/shared/confirm-service';

const cssPrefix = 'add-new-user';
@Component({
  components: {
    ...UUIFComponents,
    SwSelect,
    SwModal,
    SwModalBody,
    SwModalFooter,
    SwButton,
    SwTextfield,
  },
})
export default class AddNewUser extends SwExtendedVue {
  cssPrefix = cssPrefix;

  @Prop({ required : true })
  displayAddNewUser : any;
  userModal : any = {
    emailAddress: '',
    firstName: '',
    lastName: '',
    contactTypeId: '',
    partyGroupId: '',
    bskipResellerCustomerValidation: false,
  };
  userGroups : any[] = [];
  showToaster: boolean = false;
  isSubmitted : boolean = false;
  inValidEmail: boolean = false;
  userGroupRes: any[] = [];
  contactTypes: any[] = [
    {
      id: '1',
      value: '1',
      label: this.$t('home.employee')
      .toString(),
    },
  ];
  buttonsTransferConfirm: ConfirmButton[];
  optionsTransferConfirm: ConfirmOptions;

  get isPartner() {
    return JSON.parse(this.$store.getters.getUserInfo)?.user?.roles
    ?.indexOf('PARTNER') > - 1;
  }

  get contactTypeTooltip(): TooltipDirValues {
    let content = '';
    content = this.$route.path.includes('org-profile') ?
    String(this.$t('userGroups.orgContentTypeText'))
    : String(this.$t('userGroups.contentTypeTooltip'));
    return {
      content,
      placement: 'top',
      compact: true,
      maxWidth: 275,
      includePopperForHover: true,
      doAnimation: true,
    };
  }

  onChangeUserGroup() {
    this.userModal.contactTypeId = '';
    this.contactTypes = [
      {
        id: '1',
        value: '1',
        label: this.$t('home.employee')
        .toString(),
      },
    ];
    this.userGroupRes.forEach((group: any) => {
      if ((group.partyGroupId === this.userModal.partyGroupId) && (group.isDefaultGroup !== 'TRUE')) {
        this.contactTypes.push(
          {
            id: '2',
            value: '2',
            label: this.isPartner ? this.$t('productClaims.customer')
            .toString() : this.$t('groups.resellerOrcustomer')
            .toString(),
          },
        );
      }
    });
  }
  checkEmail() {
    const regexStr =  new RegExp(RegexValidators.email);
    this.inValidEmail = !regexStr.test(this.userModal.emailAddress);
  }

  showConfirmDialog(message: string) {
    this.buttonsTransferConfirm = [
      {
        key: 'cancel',
        name: this.$t('common.cancel')
        .toString(),
        isDefault: true,
      },
      {
        key: 'save',
        name: this.$t('common.yes')
        .toString(),
      },
    ];
    this.optionsTransferConfirm = {
      message,
      status: 'informational',
      title: 'Warning',
      buttons: this.buttonsTransferConfirm,
    };
    return confirmService.confirm(this.optionsTransferConfirm);
  }

  openConfirmDialog(resp: any) {
    this.showConfirmDialog(resp.msgDesc)
    .then((key) => {
      if (key === 'save') {
        this.addUser();
      }
    });
  }

  checkValidation() {
    let validateFlag = true;
    if (this.userModal.emailAddress.trim().length === 0 || this.inValidEmail) {
      validateFlag = false;
    }
    if (this.userModal.firstName.trim().length === 0) {
      validateFlag = false;
    }
    if (this.userModal.lastName.trim().length === 0) {
      validateFlag = false;
    }
    return validateFlag;
  }

  addUser() {
    this.isSubmitted = true;
    let contactTypeId: any = '';
    let partyGroupName: any = '';
    if (this.userModal.contactTypeId === '') {
      this.showToaster = true;
      return;
    }
    if (this.checkValidation()) {
      if (this.userModal.contactTypeId === '1') {
        contactTypeId = 10001;
      } else if (this.userModal.contactTypeId === '2') {
        this.isPartner ? contactTypeId = 10006 : contactTypeId = 10015;
      }
      for (const el of this.userGroups) {
        if (el.id === this.userModal.partyGroupId) {
          partyGroupName = el.label;
        }
      }
      const payload = {
        contactTypeId,
        partyGroupName,
        emailAddress: this.userModal.emailAddress,
        firstName: this.userModal.firstName,
        lastName: this.userModal.lastName,
        partyGroupId: this.userModal.partyGroupId,
        bskipResellerCustomerValidation: this.userModal.bskipResellerCustomerValidation,
      };
      this.$store.dispatch('SnbProfileStoreModule/addNewUser', payload)
      .then((resp : any) => {
        this.$store.commit('stopLoading');
        if (resp?.operationStatus === 'OK') {
          this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
          this.$emit('close-modal');
          this.$emit('update-user-list');
        } else if (resp?.msgCode === 'MSWAPP:ADDUSERWARNING') {
          this.userModal.bskipResellerCustomerValidation = true;
          this.openConfirmDialog(resp);
        } else {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
        }
      });
    }
  }

  getUserGroups() {
    this.$store.commit('startLoading');
    this.$store.dispatch('SnbProfileStoreModule/getUserGroups')
    .then((response : any) => {
      this.$store.commit('stopLoading');
      if (response.operationStatus === 'OK') {
        this.userGroupRes = response?.userGroups;
        this.userGroups = response?.userGroups?.map((group: any) => {
          return {
            id: group.partyGroupId,
            value: group.partyGroupId,
            label: group.partyGroupName,
          };
        }) || [];
        this.userModal.partyGroupId = this.userGroups[0].id;
      }
    });
  }

  created() {
    this.getUserGroups();
  }

  closeDialog() {
    this.$emit('close-modal');
  }

  cancel() {
    this.showToaster = false;
    this.$emit('close-modal');
  }
}
